<div class="info-wrap">

  <div class="kan-container">

    <!-- LEFT: Information Panel -->
    <div class="kan-info">
      <span class="badge">Neural Architecture</span>
      <h1>Convolutional Neural <span>Networks</span></h1>
      <div class="divider"></div>

      <p>
        A Convolutional Neural Network (CNN) is a specialized deep learning architecture designed to process grid-structured data, such as images and video. Inspired by the human visual cortex, it excels at recognizing spatial patterns, textures, and objects by automatically extracting hierarchical features without manual human intervention
      </p>

      <div class="tag-row">
        <span class="tag">Deep Learning</span>
        <span class="tag">Feature Map</span>
        <span class="tag">Kernel</span>
        <span class="tag">Padding</span>
        <span class="tag">Pooling</span>
      </div>
    </div>

    <!-- RIGHT: Image Panel -->
    <div class="kan-image">
      <span class="image-label">CNN Architecture Diagram</span>
      <img
        src="https://media.licdn.com/dms/image/v2/D4D12AQEzixCP0pZ1nQ/article-inline_image-shrink_1000_1488/article-inline_image-shrink_1000_1488/0/1714646204015?e=2147483647&v=beta&t=XlVX_VOs_tGfopsKSy5b-6s5GSylGo5CmJ__Y3Dp6FM"
        alt="Kolmogorov-Arnold Network Architecture Diagram"
      />
      <p class="image-caption">
        A CNN architecture where convolutional layers automatically learn spatial hierarchies of features, enabling powerful image recognition capabilities.
      </p>
    </div>

  </div>


  <!-- Quick Facts -->
  <div class="facts-strip">
    <div class="fact-item" *ngFor="let f of facts">
      <span class="fact-icon">{{ f.icon }}</span>
      <div>
        <div class="fact-label">{{ f.label }}</div>
        <div class="fact-value">{{ f.value }}</div>
      </div>
    </div>
  </div>


   <section class="section">
    <h2 class="section-title"></h2>

    <div class="model-cards">

      <div class="mcard mcard-cnn">
        <div class="mcard-top">
          <span class="mcard-icon"></span>
          <h3>Feature Extraction</h3>
        </div>
        <p>
          Feature extraction is the process by which CNNs automatically learn to identify and represent important patterns in the input data, such as edges, textures, and shapes. This hierarchical learning allows CNNs to excel at tasks like image classification and object detection.
        </p>
        <div class="mcard-tag">Feature Extraction · CNN</div>
      </div>

      <div class="mcard mcard-loss">
        <!-- <div class="mcard-top">
          <span class="mcard-icon">🔬</span>
          <h3>KAN</h3>
        </div>
        <p>
          <strong>Kolmogorov–Arnold Networks</strong> replace conventional
          node-level activation functions with <em>learnable, spline-based
          functions on edges</em>. Grounded in the Kolmogorov–Arnold
          representation theorem, KAN offers unprecedented interpretability
          alongside competitive accuracy.
        </p>
        <div class="mcard-tag">New Architecture · 2024</div> -->
        <!-- <img src="../../../modelcomparisonchart.png" alt="demo"/> -->
      </div>
      
      




    </div>
  </section>

  <section class="section">
    <h2 class="section-title"></h2>

    <div class="model-cards">

      <div class="mcard mcard-pooling">
        <!-- <div class="mcard-top">
          <span class="mcard-icon">🔬</span>
          <h3>KAN</h3>
        </div>
        <p>
          <strong>Kolmogorov–Arnold Networks</strong> replace conventional
          node-level activation functions with <em>learnable, spline-based
          functions on edges</em>. Grounded in the Kolmogorov–Arnold
          representation theorem, KAN offers unprecedented interpretability
          alongside competitive accuracy.
        </p>
        <div class="mcard-tag">New Architecture · 2024</div> -->
        <!-- <img src="../../../modelcomparisonchart.png" alt="demo"/> -->
      </div>
      
      <div class="mcard mcard-cnn">
        <div class="mcard-top">
          <span class="mcard-icon">📉</span>
          <h3>Pooling</h3>
        </div>
        <p>
          Pooling is a downsampling operation in CNNs that reduces the spatial dimensions of feature maps while retaining important information. Pooling helps to make the model more robust to spatial variations and reduces computational complexity.
        </p>
        <div class="mcard-tag">Pooling in CNN </div>
      </div>

      
      
      




    </div>
  </section>

  <h3 style="text-align:center;color:var(--blue);">Learn by doing: Explore CNN Playground</h3>

  <div class="browser-wrapper">

    <!-- Title Bar with Traffic Lights -->
    <div class="browser-title-bar">
      <span class="dot red"></span>
      <span class="dot yellow"></span>
      <span class="dot green"></span>
    </div>

    <!-- Tab Bar -->
    <div class="browser-tab-bar">

      <!-- Active Tab -->
      <div class="browser-tab active">
        <img
          class="tab-favicon"
          src="https://www.google.com/s2/favicons?domain=wikipedia.org"
          alt="favicon"
        />
        <span>KAN — Wikipedia</span>
        <span class="tab-close">&#x2715;</span>
      </div>

      <!-- Inactive Tab -->
      <div class="browser-tab inactive">
        <img
          class="tab-favicon"
          src="https://www.google.com/s2/favicons?domain=github.com"
          alt="favicon"
        />
        <span>GitHub</span>
        <span class="tab-close">&#x2715;</span>
      </div>

      <!-- New Tab Button -->
      <button class="new-tab-btn" title="New Tab">&#43;</button>

    </div>

    <!-- Address Bar -->
    <div class="browser-address-bar">
      <button class="browser-nav-btn" title="Back">&#8592;</button>
      <button class="browser-nav-btn" title="Forward">&#8594;</button>
      <button class="browser-nav-btn" title="Reload">&#8635;</button>

      <div class="address-input-wrapper">
        <span class="lock-icon">&#128274;</span>
        <input
          type="text"
          value="https://en.wikipedia.org/wiki/Kolmogorov%E2%80%93Arnold_Networks"
          readonly
        />
      </div>

      <button class="browser-menu-btn" title="Menu">&#8942;</button>
    </div>

    <!-- IFrame Content -->
    <iframe
      class="browser-content"
      src="https://poloclub.github.io/cnn-explainer/"
      title="KAN Wikipedia Page"
      sandbox="allow-scripts allow-same-origin"
    ></iframe>

  </div>
  <!-- Main Grid -->
  <section class="section">
    <h2 class="section-title">✨ Advantages</h2>

    <div class="adv-grid">
      <div class="adv-card"
           *ngFor="let a of advantages"
           [style.background]="a.color">
        <span class="adv-icon">{{ a.icon }}</span>
        <h4>{{ a.title }}</h4>
        <p>{{ a.desc }}</p>
      </div>
    </div>
  </section>
</div>